import apiClient from "./apiClient";

const menuService = {
  async getNavigationMenus() {
    try {
      const token = localStorage.getItem("access_token");
      if (!token) return [];
      const response = await apiClient.get("/api/admin/navigation", {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data || [];
    } catch {
      return [];
    }
  },
};

export default menuService;
